import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdsSwiper from "../../Ads/components/detailComponents/AdsSwiper";
import SelectOptionButton from "../components/detailComponents/SelectOptionButton";
import InstaTextArea from "../components/detailComponents/InstaTextArea";
import couponImg from "../../../assets/image/icon/coupon.png";
import { addAppMessageListener, postToApp } from "../../../bridges/appBridge";
import useFormattedDateOnce from "../../../hooks/useFormattedDate";
import platformFromChannel from "../../../hooks/getPlatform";
import useTemplateCapture from "../../../hooks/useTemplateCapture";
import useStrictBackBlock from "../../../bridges/useStrictBackBlock";
import { useRecordsStore } from "../../../stores/useReordsStore";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import home from "../../../assets/icons/System/close.svg";
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import retry from "../../../assets/icons/System/repeat_primary.svg";
import { Chip } from "../../../assets/components/Chip";
import { useFixedLayout } from "../../../hooks/useFixedLayout";
import { useToastOffset } from "../../../hooks/useToastOffset";
import checkOn from "../../../assets/icons/Select/check_checked.svg"
import checkOff from "../../../assets/icons/Select/check_unchecked.svg"
import TokenPopup from "../../Ads/components/detailComponents/TokenPopup";
import Popup from "../../../assets/components/PopupGroup";
import { TwinColumn } from "../../../assets/components/ButtonGroup";
import { useAddAIGeneratedWatermark } from "../../../hooks/useAddAIGeneratedWatermark";

const titleOptions = {
    1: "매장 홍보",
    2: "상품 소개",
    3: "이벤트",
    4: "감사 인사",
};

const channelOptions = {
    1: "카카오톡",
    2: "인스타 스토리",
    3: "인스타 게시물",
    6: "네이버 밴드",
};

const ageOptions = {
    1: "10대",
    2: "20대",
    3: "30대",
    4: "40대",
    5: "50대",
    6: "60대 이상",
};

const AutoMarketingResult = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const addWatermark = useAddAIGeneratedWatermark();

    // 글로벌 기록 스토어 저장용
    const addRecord = useRecordsStore((s) => s.addRecord);

    const { tokenAll, ...state } = location.state || {};

    // 초기 값
    let {
        store_business_number: storeBusinessNumber,
        origin_image,
        style: initStyle,
        title: initTitle,
        channel: initChannel,
        insta_copyright,
        copyright,
        core_f,
        store_name,
        road_name,
        district_name,
        main,
        temp,
        detail_category_name,
        register_tag,
        custom_menu,
        prompt,
        ad_text,
        event_title,
        route,
        category,
    } = state || {};

    if (initTitle === "3" && event_title?.trim() && !route) {
        copyright = `제목 : ${event_title} 내용 : ${copyright ?? ""}`;
    }

    const effectiveTag =
        register_tag ??
        localStorage.getItem("registerTag") ??
        detail_category_name;

    const imageSrc = `data:image/png;base64,${origin_image?.[0]}`;
    const [weekday, setWeekday] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [checkedBox] = useState(false);
    const [sharePending, setSharePending] = useState(false);
    const { fullDate, onlyDate, onlyTime } = useFormattedDateOnce();
    const captureImageFromTemplate = useTemplateCapture({
        checked: checkedBox,
        couponImg,
    });
    const [showTokenModal, setShowTokenModal] = useState(false);



    // 1) 상하단 고정 훅
    const {
        headerRef,
        footerRef,
        headerSpace,
        bottomSpace,
    } = useFixedLayout();

    // 2) 토스트 위치 훅 (footer 기준 + 키보드 대응)
    const toastOffset = useToastOffset({
        footerRef,
        bottomSpace,
        gap: 8,
    });


    useEffect(() => {
        const handleMessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                if (data.type === "SHARE_INSTAGRAM") {
                    const url = data.payload.url;
                    window.Android?.shareInstagram(url); // ✅ 안드로이드 native 함수 호출
                }
            } catch (e) {
                console.error("메시지 처리 오류", e);
            }
        };

        document.addEventListener("message", handleMessage);

        return () => {
            document.removeEventListener("message", handleMessage);
        };
    }, []);

    useEffect(() => {
        const daysOfWeek = [
            "일요일",
            "월요일",
            "화요일",
            "수요일",
            "목요일",
            "금요일",
            "토요일",
        ];
        const today = new Date().getDay();
        setWeekday(daysOfWeek[today]);
    }, []);

    const [skipRegenPopup, setSkipRegenPopup] = useState(() => {
        try {
            const v = localStorage.getItem("re_popup");
            // 서버에서 bool → localStorage 저장 시 "true" / "false" 문자열이라고 가정
            return v === "true";
        } catch {
            return false;
        }
    });

    // ✅ 키 (유저별로 분리 추천)
    const REGEN_SAME_OPTION_KEY = `regen_same_option:${localStorage.getItem("user_id") || "guest"}`;

    // ✅ 체크박스 state: localStorage 값으로 초기화
    const [regenWithSameOption, setRegenWithSameOption] = useState(() => {
        try {
            const v = localStorage.getItem(REGEN_SAME_OPTION_KEY);
            return v === null ? true : v === "true"; // 없으면 기본 true
        } catch {
            return true;
        }
    });

    // ✅ 값이 바뀔 때마다 저장
    useEffect(() => {
        try {
            localStorage.setItem(REGEN_SAME_OPTION_KEY, String(regenWithSameOption));
        } catch { }
    }, [REGEN_SAME_OPTION_KEY, regenWithSameOption]);


    const handleEdit = () => {
        if (tokenAll <= 0) {
            setShowTokenModal(true);
            return;
        }

        navigate("/auto/marketing/regen", {
            state: {
                data: {
                    store_business_number: storeBusinessNumber,
                    style: String(initStyle),
                    title: String(initTitle),
                    channel: String(initChannel),
                    age: String(core_f),
                    prompt: prompt || null,
                    main,
                    temp,
                    store_name,
                    detail_category_name,
                    custom_menu,
                    road_name,
                    district_name,
                    register_tag: localStorage.getItem("registerTag"),
                    ad_text,
                    category,
                },
            },
        });
    };

    const selectedTags = [
        { key: "age", prefix: "고객", label: ageOptions[core_f] },
        {
            key: "channel",
            prefix: "채널",
            label: channelOptions[initChannel],
        },
        {
            key: "title",
            prefix: "맞춤주제",
            label: titleOptions[initTitle],
        },
    ];

    // 생성된 이미지 처리
    const [checkImages, setCheckImages] = useState([]); // 선택된 이미지들의 인덱스

    // 이미지 선택 되게끔
    const handleImageClick = (index) => {

        setCheckImages([index]);

    };

    const returnHome = () => {
        navigate("/ads/main", { state: { storeBusinessNumber } });
    };

    // 인스타 텍스트 처리
    const [instaText, setInstaText] = useState(insta_copyright || "");

    const handleTextChange = (e) => {
        setInstaText(e.target.value);
    };

    const reGenerate = () => {
        navigate(`/auto/marketing/regen/loading`, {
            state: {
                style: String(initStyle),
                title: String(initTitle),
                channel: String(initChannel),
                age: String(core_f),
                prompt: prompt || "기본 프롬프트",
                main: main,
                temp: temp,
                store_name: store_name,
                detail_category_name: detail_category_name,
                custom_menu: localStorage.getItem("customMenu"),
                register_tag: localStorage.getItem("registerTag"),
                road_name: road_name,
                district_name: district_name,
                store_business_number: storeBusinessNumber,
                ad_text,
            },
        });
    };

    // 팝업창
    const [popupOpen, setPopupOpen] = useState(false);
    const onOut = () => {
        setPopupOpen(false);
    }
    const [noPopup, setNoPopup] = useState(false); // 기본: 체크 ON
    // const popupLocal = localStorage.getItem("popup");
    const NoPopup = () => {
        setNoPopup((prev) => !prev);
    };

    // 🔹 “다시 생성하기” 버튼 클릭 시 → 팝업만 열기
    const handleRegenClick = () => {
        if (tokenAll <= 0) {
            setShowTokenModal(true);
            return;
        }

        // ✅ 옵션 그대로 다시 생성 체크 O → 팝업 열기
        if (regenWithSameOption) {
            if (skipRegenPopup) {
                reGenerate();     // ✅ 팝업 없이 바로 재생성
                return;
            }
            setPopupOpen(true); // ✅ 팝업 표시
            return;
        }

        // ✅ 체크 X → 바로 기존 edit 페이지로 이동
        handleEdit();
    };

    const handlePopupConfirm = async () => {
        const userId = localStorage.getItem("user_id");

        if (noPopup && !skipRegenPopup && userId) {
            try {
                await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/re_popup`, {
                    user_id: userId,
                    re_popup: true,
                });
                localStorage.setItem("re_popup", "true");
                setSkipRegenPopup(true);
            } catch (err) {
                console.log("re_popup save error", err);
            }
        }

        setPopupOpen(false);
        reGenerate();
    };

    const popupSubtitle = (
        <div className="space-y-1 text-b2">
            <p>이전 옵션 그대로 생성하시겠습니까? 옵션을 변경할 수 있어요.</p>
            <p className="text-text-danger text-b2">
                * 이미지를 재생성할 경우 토큰이 차감됩니다.
            </p>
        </div>
    );







    // 업로드
    const onUpload = async () => {
        setIsLoading(true);

        let useOptionPath = "";
        let titlePath = "";

        if (initTitle === "1" || initTitle === "2") {
            titlePath = "intro";
        } else if (initTitle === "3") {
            titlePath = "event";
        }

        if (initChannel === "1" || initChannel === "2") {
            useOptionPath = "4to7";
        } else if (
            initChannel === "3" ||
            initChannel === "4" ||
            initChannel === "6"
        ) {
            useOptionPath = "1to1";
        }

        const index = checkImages?.[0];
        const key = `template_${titlePath}_${useOptionPath}_${index}`;

        if (index === undefined || index === null) {
            console.log({ index });
            alert("템플릿이 적용된 이미지를 선택해 주세요.");
            setIsLoading(false);
            return;
        }

        // 3) 이미지 생성: exporter 우선, 없으면 기존 캡처 함수 폴백
        let imageData;
        const exporter = window.__templateExports?.[key];

        try {
            if (typeof exporter === "function") {
                // 템플릿 내부에서 캔버스로 직접 합성 (화면=저장 1:1)
                // 보통 dataURL(jpeg/png) 반환
                imageData = await exporter();
            } else {
                // 기존 방식 유지
                imageData = await captureImageFromTemplate(
                    index,
                    titlePath,
                    useOptionPath
                );
            }
        } catch (e) {
            console.error("exporter/capture 실패:", e);
            // 최종 폴백 한 번 더 시도
            imageData = await captureImageFromTemplate(
                index,
                titlePath,
                useOptionPath
            );
        }

        if (index === 0) {
            imageData = imageSrc; // 이미 data:image/png;base64, ... 형식
        }

        const watermarkedImageData = await addWatermark(imageData);

        const data = {
            title: initTitle + "",
            age: core_f + "0",
            style: initStyle + "",
            channel: initChannel + "",
            repeat: "없음",
            date_range: [onlyDate, onlyDate],
            upload_time: onlyTime,
            alert_check: false,
            user_id: localStorage.getItem("user_id"),
            image: watermarkedImageData,
            type: "auto",
            insta_copyright: instaText || "",
            copyright: copyright,
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/app/save`,
                data,
                { headers: { "Content-Type": "application/json" } }
            );
            const { success, imageUrl } = response.data || {};

            if (success && imageUrl) {
                // console.log("저장된 경로:", imageUrl);
                // 기록 저장
                const newRecord = {
                    image_path: imageUrl, // 썸네일/원본 URL
                    title: String(initTitle), // "1" | "2" | "3"
                    age: typeof core_f === "string" ? Number(core_f) : core_f,
                    style: initStyle, // 숫자 or 문자열: Records에서 쓰는 타입에 맞추기
                    channel: Number(initChannel),
                    repeat_time: "없음",
                    start_date: onlyDate,
                    end_date: onlyDate,
                    insta_copyright: instaText,
                    copyright: copyright,
                };

                // ✅ 전역 즉시 반영 (네트워크 재조회 없이 홈/Records가 바로 갱신됨)
                addRecord(newRecord);

                // 앱에 넘기기
                // Web → App 표준 브릿지: START_SHARE 전송
                const requestId = Math.random().toString(36).slice(2);

                // const makeNaverSearchUrl = (name, region) =>
                //     `https://map.naver.com/p/search/${encodeURIComponent(`${region} ${name}`)}`;
                const platform = platformFromChannel(initChannel);
                let link = "";
                // if (platform === 'KAKAO') {
                //     link = makeNaverSearchUrl((localStorage.getItem("storeName")), (localStorage.getItem("roadName")));
                // }
                if (platform === "KAKAO") {
                    const name = (
                        localStorage.getItem("storeName") || ""
                    ).trim();
                    const region = (
                        localStorage.getItem("roadName") || ""
                    ).trim();
                    if (name && region) {
                        const label = `${region} ${name}`.trim();
                        const long = `https://map.naver.com/p/search/${encodeURIComponent(
                            label
                        )}`;
                        // 👇 성공시에만 link 세팅, 실패하면 빈 문자열 유지
                        link = await axios
                            .post(
                                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/g`,
                                { url: long }
                            )
                            .then((r) => r.data?.short || "")
                            .catch(() => "");
                    }
                }

                setSharePending(true);
                postToApp({
                    type: "share.toChannel",
                    requestId,
                    social: platform,
                    data: {
                        imageUrl: imageUrl,
                        caption: instaText || "",
                        // hashtags: "#wizmarket",
                        couponEnabled: false,
                        // link: link
                        ...(platform === "KAKAO" && link && { link }),
                    },
                });
                // DEV 환경(브라우저) 폴백
                if (!window.ReactNativeWebView) {
                    // console.log("[DEV] START_SHARE", { platform, caption: instaText, imageUrl: imageUrl.slice(0, 64) + "..." });

                    navigate("/auto/marketing/final", {
                        state: {
                            image: watermarkedImageData,
                            selections: {
                                title: initTitle,
                                age: core_f + "0",
                                channel: initChannel,
                                style: initStyle,
                            },
                            instaText: instaText || "",
                            storeBusinessNumber,
                            type: "manual",
                            time: fullDate,
                        },
                    });
                }

                // 앱의 SHARE_RESULT를 기다렸다가 이동
                const off = addAppMessageListener((msg) => {
                    if (msg?.type !== "SHARE_RESULT") return;
                    // (선택) 플랫폼 매칭: 동시에 여러 공유가 있을 때 안전
                    if (
                        msg?.payload?.platform &&
                        msg.payload.platform !== platform
                    )
                        return;

                    off?.();
                    setSharePending(false);

                    const payload = msg.payload || {};
                    const ok = payload.success === true;
                    const errorCode = payload.error_code;
                    const cancelled = payload.cancelled;


                    if (ok) {
                        navigate("/auto/marketing/final", {
                            state: {
                                image: watermarkedImageData,
                                selections: {
                                    title: initTitle,
                                    age: core_f + "0",
                                    channel: initChannel,
                                    style: initStyle,
                                },
                                instaText: instaText || "",
                                storeBusinessNumber,
                                type: "auto",
                                time: fullDate,
                            },
                        });
                        return
                    }
                    // 2) 앱 미설치 + 스토어로 보낸 케이스 → 아무 알럿도 안 띄우고 조용히 종료
                    if (errorCode === "app_not_installed") {
                        // 필요하면 토스트 정도는 가능
                        // showToast("앱 설치 후 다시 시도해 주세요.");
                        return;
                    }

                    // 3) 사용자가 네이티브에서 취소한 경우 → 조용히 종료 (원하면 토스트)
                    if (cancelled) {
                        // showToast("공유가 취소되었어요.");
                        return;
                    }

                    // 4) 그 외 진짜 에러일 때만 알럿
                    alert("공유 중 오류가 발생했습니다. 다시 시도해 주세요.");
                });

                // 응답 없으면 아무것도 하지 않기 — 타임아웃 콜백만 정리
                setTimeout(() => {
                    off?.();
                    setSharePending(false);
                }, 150000);
            } else {
                alert("저장 실패");
            }
        } catch (error) {
            console.error("백엔드 요청 실패:", error);
            alert("저장 오류");
        } finally {
            setIsLoading(false);
        }
    };

    useStrictBackBlock(true);

    return (
        <div className="h-dvh flex flex-col">
            <div
                ref={headerRef}
                className="fixed top-0 left-0 right-0 z-10"
            >
                <HeaderIconL
                    className=""
                    title="생성 완료"
                    icon={home}
                    onIconClick={returnHome}
                />
            </div>

            <div
                className="flex-1 px-[16px] overflow-y-auto"
                style={{ paddingTop: headerSpace, paddingBottom: bottomSpace }}
            >
                <div className="flex flex-col pt-[16px] gap-[8px]">
                    <h2 className="text-t2 text-text-default">완성되었습니다✨</h2>
                    <p className="text-b2 text-text-subtler">
                        원하는 이미지 1개를 포스팅해 보세요.
                    </p>
                </div>

                <div className="mt-[24px] w-full bg-surface-light-subtle p-[12px] pl-[16px] rounded-[16px]">
                    <div className="flex items-center justify-between gap-[8px]">
                        <div className="text-t4 text-text-subtle">옵션 설정</div>
                        <Chip
                            chip="d"
                            status="selected"
                            label="변경하기"
                            onClick={handleEdit}
                        />
                    </div>
                    <SelectOptionButton
                        selectedTags={selectedTags}
                    // onEdit={handleEdit}
                    />
                </div>

                <AdsSwiper
                    imageTemplateList={[imageSrc]}
                    content={copyright.replace(/["']/g, "").trim()}
                    title={initTitle || "1"}
                    useOption={initChannel || "1"}
                    checkImages={checkImages}
                    handleImageClick={handleImageClick}
                    storeName={store_name}
                    roadName={road_name}
                    weather={main}
                    tag={effectiveTag}
                    weekday={weekday}
                    checkedBox={checkedBox}
                    toastBottomOffset={toastOffset}
                />

                {instaText && (
                    <InstaTextArea
                        channel={channelOptions[initChannel]}
                        value={instaText}
                        onChange={handleTextChange}
                        toastBottomOffset={toastOffset}
                    />
                )}
            </div>

            <div ref={footerRef} className="fixed bottom-0 left-0 right-0 z-10">
                <div className="px-[16px] pt-[12px] bg-surface-light-white">
                    <label className="inline-flex items-center">
                        <input
                            type="checkbox"
                            checked={regenWithSameOption}
                            onChange={(e) => setRegenWithSameOption(e.target.checked)}
                            className="sr-only"
                        />

                        <img
                            src={regenWithSameOption ? checkOn : checkOff}
                            alt={regenWithSameOption ? "옵션 그대로 다시 생성: 켜짐" : "옵션 그대로 다시 생성: 꺼짐"}
                        />
                        <span
                            className={`pl-[4px] text-b1 text-text-subtle`}
                        >
                            옵션 그대로 다시 생성
                        </span>
                    </label>
                </div>
                <SplitRowHalf
                    leftText="다시 생성하기"
                    rightText="포스팅하기"
                    leftLeftIcon={retry}
                    onLeft={handleRegenClick}
                    onRight={onUpload}
                    leftType="border"
                    rightType={isLoading ? "gray" : "fill"}
                    disabled={isLoading || sharePending}
                />
            </div>
            <TokenPopup
                isOpen={showTokenModal}
                onClose={() => setShowTokenModal(false)}
            />
            <Popup
                isOpen={popupOpen}
                onClose={onOut}
                title={"다시 생성하기"}        // ✅ 동적 타이틀
                subtitle={popupSubtitle}  // ✅ 동적 서브텍스트
                renderButtons={
                    <>
                        <button
                            type="button"
                            className="flex items-center p-[24px] pb-[16px]"
                            onClick={NoPopup}
                        >
                            <img
                                src={noPopup ? checkOn : checkOff}
                                alt=""
                                className="pr-[8px]"
                            />
                            <span className={`text-b1 ${noPopup ? "text-text-default" : "text-text-disabled"}`}>
                                다시 보지 않기
                            </span>
                        </button>
                        <TwinColumn
                            topType={"fill"}
                            topText={"다시 생성하기"}   // ✅ 버튼 텍스트도 분기
                            onTop={handlePopupConfirm}   // ✅ 위에서 만든 함수 사용
                            bottomType={"empty"}
                            bottomText={"취소"}
                            onBottom={onOut}
                        />
                    </>
                }
            />

        </div >
    );
};

export default AutoMarketingResult;